import { identityActions, service } from '..';

const endpoint = 'identity';

export const identityService = {
  //  get: cId => service( endpoint ).get( ['get', cId] ).then( result => ( { data: result.data, type: identityActions.LOAD } ) )
  get: cId  => service( endpoint ).get( ['get', cId ] ).then( result => ( { data: result.data, type: identityActions.LOAD } ) )
  // get: cId  => service( endpoint ).get( ['get', cId + '?'+`t=${new Date().getTime()}`] ).then( result => ( { data: result.data, type: identityActions.LOAD } ) )
};